import BaseAPI from '../BaseAPI.js'

export default class extends BaseAPI {
  _resource ='contact'
}
